import { render, staticRenderFns } from "./ThirteenthMonth.vue?vue&type=template&id=7a4c74b0"
import script from "./ThirteenthMonth.vue?vue&type=script&lang=js"
export * from "./ThirteenthMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports